import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Configs } from 'constants/configs'
import axios from 'axios'
import { AppRouter } from 'AppRouter'
import { AuthProvider } from 'context/authContext'

const queryClient = new QueryClient()
axios.defaults.baseURL = Configs.baseUrl

function App() {
    return (
        <AuthProvider>
            <QueryClientProvider client={queryClient}>
                <ReactQueryDevtools initialIsOpen={false} />
                <AppRouter />
            </QueryClientProvider>
        </AuthProvider>
    )
}

export default App
